import React, { useCallback, useMemo } from 'react'
import { RowSortable } from './RowSortable'
import type { TableProps } from './index'

export const TableContent = ({ onSelect, head, dataArray, className, foot, tableClassName, responsive = ' ', ...rest }: TableProps) => {
  const [currentItem, setCurrentItem] = React.useState(null)

  const computedClassName = useMemo(() => `${responsive} ${className}`, [responsive, className])
  const computedTableClassName = useMemo(() => tableClassName || 'table table-hover table-striped', [tableClassName])

  const handleSelect = useCallback((item) => {
    setCurrentItem(item)
    onSelect?.(item)
  }, [onSelect])

  const rowSortableProps = useMemo(() => ({
    onSelect,
    head,
    className: computedClassName,
    foot,
    dataArray,
    tableClassName: computedTableClassName,
    responsive,
    currentItem,
    handleSelect,
    ...rest,
  }), [onSelect, head, computedClassName, foot, dataArray, computedTableClassName, responsive, currentItem, handleSelect, rest])

  return (
    <table className={computedTableClassName}>
      {head}
      <RowSortable {...rowSortableProps} />
      {foot}
    </table>
  )
}
